/**
 * LENKE INN I TILGANG-SKUFFEN (FELLES.md, grensesnitt 4): `?access=1` på advancens adresse åpner
 * skuffen, og `&accessPerson=<personId>` åpner personens gruppe og markerer raden.
 *
 * Adressene er festivalens programpost, byråets advance, spillestedets arrangement og konserten.
 * Rutene med `validateSearch` slipper ellers ukjente parametre av, så hver av dem fletter dette inn.
 * Byråets advance har ingen `validateSearch`; der leser siden parametrene rått, og ruteren har da
 * tolket `1` som et tall — derfor godtas både tall, tekst og `true`.
 */

export interface AccessSearch {
  access?: 1;
  accessPerson?: string;
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function validateAccessSearch(search: Record<string, unknown>): AccessSearch {
  const flag = search['access'];
  const person = search['accessPerson'];
  const on = flag === 1 || flag === '1' || flag === true || flag === 'true';
  if (!on) return {};
  return {
    access: 1,
    ...(typeof person === 'string' && UUID.test(person) ? { accessPerson: person } : {}),
  };
}

/** Søkeparametrene en liste lenker med (D): `search: { ...accessSearch(personId) }`. */
export function accessSearch(personId?: string): AccessSearch {
  return { access: 1, ...(personId === undefined ? {} : { accessPerson: personId }) };
}
